import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TenantService } from '../../plateformebeneficiaire/core/service/tenant.service';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  private translations: any = {};

  constructor(
    private http: HttpClient,
    private tenantService: TenantService
  ) {}

  loadTranslations(lang: string = 'fr'): Observable<any> {
    const tenant = this.tenantService.getTenant();
    const translationFile = `/assets/i18n/${tenant?.name}/${lang}.json`;

    return this.http.get(translationFile).pipe(
      catchError((error) => {
        console.error('Error loading translations:', error);
        return of({}); // Retourne un objet vide en cas d'erreur
      })
    );
  }

  
  getTranslation(key: string): any {
    return key.split('.').reduce((obj, k) => (obj && obj[k] !== undefined ? obj[k] : null), this.translations);
  }

  private resolveKey(obj: any, keys: string[]): any {
    if (!obj || keys.length === 0) {
      return '';
    }
    const [currentKey, ...restKeys] = keys;
    if (obj[currentKey] !== undefined) {
      return this.resolveKey(obj[currentKey], restKeys);
    }
    return ''; // Retourne une chaîne vide si la clé n'est pas trouvée
  }

  setTranslations(translations: any): void {
    this.translations = translations;
  }
}